import { colors, fonts } from '@grupoboticario/flora-tokens/dist/oui/web/ds'

export const oui = {
  colors,
  fonts,
}
